import moment from 'moment';
import momentTz from 'moment-timezone';

const DEFAULT_DATE_FORMAT = 'MM/DD/YYYY';
const DEFAULT_TIME_FORMAT = 'h:mm A';
const MIDNIGHT = moment('12:00a', DEFAULT_TIME_FORMAT);
const DEFAULT_MIN_DAY = '1970-01-02';
const DEFAULT_MAX_DAY = '2038-01-01';
const DB_DATE_FORMAT = 'YYYY-MM-DD';
const DEFAULT_TIMEZONE = 'US/Pacific';

const getDateFormat = async () => {
  const formatTest = /(?=.*?\bMM)(?=.*?\bDD)(?=.*?\bYYYY).*/;
  let dateFormat;

  try {
    dateFormat = await window.lsCloud.Options.get('date_format');
  } catch (e) {
    dateFormat = DEFAULT_DATE_FORMAT;
  }

  dateFormat = dateFormat
    .replace('m', 'MM')
    .replace('d', 'DD')
    .replace(/y+/i, 'YYYY');

  return formatTest.test(dateFormat) ? dateFormat : DEFAULT_DATE_FORMAT;
};

const getDateTimeFormat = async () => {
  const dateFormat = await getDateFormat();

  return `${dateFormat} ${DEFAULT_TIME_FORMAT}`;
};

const changeDate = ({ oldDate, newDate }) =>
  moment(oldDate).set({
    year: newDate.get('year'),
    month: newDate.get('month'),
    date: newDate.get('date'),
  });

const changeTime = ({ oldDate, newDate }) =>
  moment(oldDate).set({
    hour: newDate.get('hour'),
    minute: newDate.get('minute'),
    second: newDate.get('second'),
    millisecond: newDate.get('millisecond'),
  });

const getTimeOffset = timezone => {
  const currentTime = momentTz.tz(timezone).format();
  return moment.parseZone(currentTime).utcOffset();
};

const offsetDate = ({ date, offset, timezone, keepTime = false }) =>
  moment(date).utcOffset(offset || getTimeOffset(timezone), keepTime);

const getDayOffset = (date, timeZone) =>
  moment(
    moment(date)
      .utcOffset(getTimeOffset(timeZone))
      .format(DB_DATE_FORMAT)
  );

const isToday = ({ date, now, offset }) => {
  const offsetNow =
    typeof offset !== 'undefined'
      ? moment(now)
          .utcOffset(offset)
          .format(DB_DATE_FORMAT)
      : moment(now).format(DB_DATE_FORMAT);

  return offsetNow === moment(date).format(DB_DATE_FORMAT);
};

const getToday = timezone =>
  timezone
    ? moment(
        momentTz()
          .tz(timezone)
          .format()
      ).startOf('day')
    : moment().startOf('day');

const getNow = timezone =>
  timezone
    ? moment(
        momentTz()
          .tz(timezone)
          .format()
      )
    : moment();

export {
  getDateFormat,
  getDateTimeFormat,
  getTimeOffset,
  getNow,
  getToday,
  offsetDate,
  getDayOffset,
  changeDate,
  changeTime,
  isToday,
  DEFAULT_DATE_FORMAT,
  DEFAULT_TIME_FORMAT,
  DEFAULT_MIN_DAY,
  DEFAULT_MAX_DAY,
  MIDNIGHT,
  DB_DATE_FORMAT,
  DEFAULT_TIMEZONE,
};
